export class DelegationSliderConstants {
    // Constants
    public static readonly DelegationLibraryTitle = 'Delegation';
    public static readonly DelegationSliderTitle = 'Create Delegation';
    public static readonly AddDelegationButonTitle = 'Add Delegation';
  
    //Spinner Messages
    public static readonly Delegate_Save_InProgress: string =
      'Delegate Save is in progress';
  
    // confirmation Messages
    public static readonly Delegate_Slider_Confirmation_Header: string =
      'Confirmation';
    public static readonly Delegate_Slider_Confirmation_Text: string =
      'Any unsaved change will be lost when closing the screen. Do you want to continue?';
  
    // Toaster Messages and Severity
    public static readonly Severity_Success: string = 'success';
    public static readonly Severity_Info: string = 'info';
    public static readonly Severity_Err: string = 'error';
  
    public static readonly Delegate_Created_Success: string =
      'Delegation Created Successfully';
    public static readonly Delegate_Creation_Failed: string =
      'Delegation Failed to save';
  
    // Error messages
    public static readonly Delegate_Scope_Required: string = 'Scope is required.';
    public static readonly Delegate_Assignment_Required: string =
      'Assignment is required.';
    public static readonly Delegate_DelegateFrom_Required: string =
      'Delegate From is required.';
    public static readonly Delegate_DelegateTo_Required: string =
      'Delegate To is required.';
    public static readonly Delegate_StartDate_Required: string =
      'Start Date is required.';
    public static readonly Delegate_Creation_Error_Message_Header_Text: string =
      'Please correct the following errors to create the Delegate.';
    public static readonly Delegate_From_To_Validation_Message: string =
      'Delegate To users must not include the Delegate From user.';
      public static readonly Linked_Item_Already_Exists_Error_Message: string =
      'This Document is already linked to the Delegation. You cannot link it again';
      public static readonly Atleast_One_Linked_Item_Must_Be_Selected_Error_Message: string=
      'At least one Document must be linked to a Delegation with a Document Scope'
      public static readonly linked_Item_Conflict_Error_Message: string=
      'This Delegation cannot be created because its content is conflicting with another Active Delegation for at least one Document selected in the Linked Items.'
  
      //const values
      public static readonly Delegate_Scope_Value: string = 'Document';
      public static readonly Delegate_Default_Requiredfields = {
        scope: false,
        assignments: false,
        delegateFrom: false,
        delegateTo: false,
        startDate: false,
      };

      public static readonly DelegationLinkedItems : string = 'Delegation Linked Items';
  }
  